export default "__VITE_ASSET__DXNX43ws__"